module.exports = __webpack_public_path__ + "static/media/dub-temnii.78368a3f.jpg";